module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner-container"
  }, _vm._l((_vm.bannerData), function(item, index) {
    return _c('div', {
      staticClass: "common-banner",
      class: _vm.clazz,
      style: ({
        'backgroundImage': 'url(' + _vm.$global.globalPath + item.src + ')',
        'text-align': item.position
      })
    }, [_c('div', {
      staticClass: "banner-content",
      class: item.position === 'center' ? '' : 'left-banner'
    }, [_c('div', {
      staticClass: "misc"
    }, [_c('h1', {
      staticClass: "banner-title f48"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.smalltitle) ? _c('h2', {
      staticClass: "banner-subtitle f36"
    }, [_vm._v(_vm._s(item.smalltitle.replace(/@/g, ' ')))]) : _vm._e(), _vm._v(" "), (_vm.hasDivider) ? _c('div', {
      staticClass: "banner-divider dib"
    }) : _vm._e(), _vm._v(" "), _c('div', [_c('p', {
      staticClass: "main-misc",
      domProps: {
        "innerHTML": _vm._s(item.content.replace(/@/g, '<br/>'))
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "buttons"
    }, [_vm._t("buttons")], 2)])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-437a3d8c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/banner.vue
// module id = 374
// module chunks = 12